// sponsorValidation.ts
import * as yup from 'yup';
import {createNameSchema} from './userFormDRCValidation';

export const sponsorDetailSchema = yup.object().shape({
  sponsor_name: createNameSchema('sponsor_name'),
  main_contact: createNameSchema('main_contact'),

  email_address: yup
    .string()
    .required('Email is required')
    .email('Invalid email address')
    .max(150, 'Email is too long')
    .matches(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      'Invalid email address',
    ),

  phone_number: yup
    .string()
    .required('Phone number is required')
    .matches(
      /^\(\d{3}\) \d{3}-\d{4}$/,
      'Invalid phone number. Please use the format (999) 999-9999',
    ),
});

export const PlaceHolderName = 'Min(1)-Max(50) Character Allowed';
// Sponsor names are full company names, so they get their own, wider hint.
export const PlaceHolderSponsorName = 'Min(1)-Max(255) Character Allowed';
export const PlaceHolderContact = 'Min(2)-Max(50) Character Allowed';
export const PlaceHolderEmail = 'emailaddress@domain.com';
export const PlaceHolderPhone = '(999) 999-9999';
export const PlaceHolderTitle = 'Min(3)-Max(50) Character Allowed';
